import React from 'react';
import './CheckboxLabel.scss';
function CheckboxLabel(_a) {
    var id = _a.id, label = _a.label;
    return (React.createElement("label", { id: id && 'elmo-checkbox-label-' + id, htmlFor: id && 'elmo-checkbox-' + id, className: "elmo-checkbox__label", "data-testid": "elmo-checkbox-label-" + (id || 'default') }, label));
}
export default CheckboxLabel;
